
const { HmacSHA256, enc, lib } = require('crypto-js');
const {randomBytes, createHash} = require("crypto");
const { HASH_ALGOS, ENCODING } = require("./constants");

const hmac_sha256 = (secret, body) => {
  return HmacSHA256(body, secret).toString(enc.Hex);
}

const rnd_string = (len) => {
  return randomBytes(len*1.5).toString('base64').substring(0, len);
}

/**
 * Hash an object into a string
 */
const hash_object = (
  obj, algo = HASH_ALGOS.sha1, encoding = ENCODING.base64) => {
  return createHash(algo)
    .update(JSON.stringify(obj)).digest(encoding);
}
module.exports = {
  hmac_sha256,
  rnd_string,
  hash_object,
}
